module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "subpage"
  }, [_c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("企业logo")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('entUpload', {
    attrs: {
      "files": _vm.params.corporateLogo,
      "preKey": "corporateLogo",
      "limit": "1"
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("头部图")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('entUpload', {
    attrs: {
      "files": _vm.params.businessRotationDiagram,
      "preKey": "businessRotationDiagram",
      "limit": "6"
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-input', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params.companyProfiles),
      callback: function($$v) {
        _vm.$set(_vm.params, "companyProfiles", $$v)
      },
      expression: "params.companyProfiles"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine adsLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("办公地址")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('ads-select', {
    ref: "adsSelect",
    attrs: {
      "adsList": _vm.preAddress
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("官网")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-input', {
    staticClass: "elInp",
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params.corporateWebsite),
      callback: function($$v) {
        _vm.$set(_vm.params, "corporateWebsite", $$v)
      },
      expression: "params.corporateWebsite"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("荣誉墙")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('entUpload', {
    attrs: {
      "files": _vm.params.corporateHonorWall,
      "preKey": "corporateHonorWall",
      "limit": "6"
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine adsLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("业务咨询")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('SvcAdd', {
    ref: "svcAdd",
    attrs: {
      "preList": _vm.preSvList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bkLine clearfix"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("工商信息显示")]), _vm._v(" "), _c('div', {
    staticClass: "iContent switchLine"
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 2
    },
    model: {
      value: (_vm.params.isDisplayBusinessInformation),
      callback: function($$v) {
        _vm.$set(_vm.params, "isDisplayBusinessInformation", $$v)
      },
      expression: "params.isDisplayBusinessInformation"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4de64ba0"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/enterpriseMent/src/Subpage3.vue
// module id = 1483
// module chunks = 1